export default __webpack_public_path__ + "images/XJ.bee356c.png";